// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"13d667e6","591":"fb69a88a","637":"ac7d6de2","788":"2198c3f3"}[chunkId] + ".chunk.js";
};